import { MutationFunction } from '@tanstack/react-query';
import { Tenant } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { TenantType } from './tenantType';
import type {
  ExtractionReviewDefaultFilter,
  ExtractionReviewViewMode,
} from 'src/types/fieldExtraction';

type UpdateTenantConfigurationParams = {
  id: string;
  enabled?: boolean;
  isSuperTenant?: boolean;
  tenantType?: TenantType;
  extractionReviewViewMode?: ExtractionReviewViewMode;
  extractionReviewDefaultFilter?: ExtractionReviewDefaultFilter;
};

type UpdateTenantResponse = {
  success: boolean;
  data: Tenant;
};

const updateTenant: MutationFunction<
  Tenant,
  UpdateTenantConfigurationParams
> = async (args) => {
  const authTokenHttp = await getCompatibleAuthTokenHttp();

  const configuration: Partial<Tenant['configuration']> = {};

  if (args.enabled !== undefined) {
    configuration.magicLinkAuth = {
      enabled: args.enabled,
    };
  }

  if (args.isSuperTenant !== undefined) {
    configuration.isSuperTenant = args.isSuperTenant;
  }

  if (args.tenantType !== undefined) {
    configuration.tenantType = args.tenantType;
  }

  if (args.extractionReviewViewMode !== undefined) {
    configuration.extractionReviewViewMode = args.extractionReviewViewMode;
  }

  if (args.extractionReviewDefaultFilter !== undefined) {
    configuration.extractionReviewDefaultFilter =
      args.extractionReviewDefaultFilter;
  }

  const response = await authTokenHttp<UpdateTenantResponse>(
    `/shared/tenants/${args.id}/configuration`,
    {
      method: 'PUT',
      body: {
        configuration,
      },
    },
  );

  if (response.data?.data) return response.data.data;

  throw new Error('Failed to update tenant configuration');
};

export default updateTenant;
